import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.9 12L12.3 18H8.5L13.1 12L8.5 6H12.3L16.9 12Z", fill: "#5E5E5E" }));
export default SvgArrowRight;
